export type FileTypeLabel = string | number | null | undefined;
export type FileTypeIcon = "video" | "audio" | "photo" | "document" | "file";

export const formatFileSize = (size?: number): string => {
  if (!size && size !== 0) return "";
  if (size < 1024) return `${size} B`;
  const kb = size / 1024;
  if (kb < 1000) return `${kb.toFixed(2)} KB`;
  return `${(size / 1048576).toFixed(2)} MB`;
};

export const formatSubtitle = (label: string, size?: number): string => {
  const sizeLabel = formatFileSize(size);
  return sizeLabel ? `${label}, ${sizeLabel} ` : label;
};

export const getFileNameFromPath = (path?: string): string => {
  if (!path) return "Arquivo sem nome";
  const cleanPath = path.split("?")[0].split("#")[0];
  const parts = cleanPath.split(/[\\/]/);
  const last = parts[parts.length - 1] || cleanPath;
  try {
    return decodeURIComponent(last);
  } catch {
    return last;
  }
};

export const mapTypeLabel = (type?: FileTypeLabel): string => {
  if (type === null || type === undefined) return "Arquivo";
  if (typeof type === "number") {
    switch (type) {
      case 1:
        return "Vídeo";
      case 2:
        return "Áudio";
      case 3:
        return "Foto";
      case 4:
        return "Documento";
      case 5:
        return "Vídeo anexado";
      case 6:
        return "Vídeo cortado";
      default:
        return "Arquivo";
    }
  }

  switch (type) {
    case "Record":
      return "Vídeo";
    case "AttachedVideo":
      return "Vídeo anexado";
    case "Video":
      return "Vídeo";
    case "Photo":
      return "Foto";
    case "Audio":
      return "Áudio";
    case "Document":
      return "Documento";
    default:
      return "Arquivo";
  }
};

export const mapTypeIcon = (type?: FileTypeLabel): FileTypeIcon => {
  if (typeof type === "number") {
    switch (type) {
      case 1:
      case 5:
      case 6:
        return "video";
      case 2:
        return "audio";
      case 3:
        return "photo";
      case 4:
        return "document";
      default:
        return "file";
    }
  }

  switch (type) {
    case "Record":
    case "AttachedVideo":
    case "Video":
      return "video";
    case "Audio":
      return "audio";
    case "Photo":
      return "photo";
    case "Document":
      return "document";
    default:
      return "file";
  }
};
